/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Pick_ErrorInputs */

const en_onboarding_v1_pick_error = /** @type {(inputs: Onboarding_V1_Pick_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong`)
};

const de_onboarding_v1_pick_error = /** @type {(inputs: Onboarding_V1_Pick_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etwas ist schiefgelaufen`)
};

const pt_br2_onboarding_v1_pick_error = /** @type {(inputs: Onboarding_V1_Pick_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo deu errado`)
};

const tr_onboarding_v1_pick_error = /** @type {(inputs: Onboarding_V1_Pick_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bir şeyler ters gitti`)
};

const zh_cn2_onboarding_v1_pick_error = /** @type {(inputs: Onboarding_V1_Pick_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出现了问题`)
};

const zh_hk2_onboarding_v1_pick_error = /** @type {(inputs: Onboarding_V1_Pick_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`發生問題`)
};

const ko_kr2_onboarding_v1_pick_error = /** @type {(inputs: Onboarding_V1_Pick_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`문제가 발생했습니다`)
};

const ru_ru2_onboarding_v1_pick_error = /** @type {(inputs: Onboarding_V1_Pick_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Что-то пошло не так`)
};

const es_419_onboarding_v1_pick_error = /** @type {(inputs: Onboarding_V1_Pick_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo salió mal`)
};

/**
* | output |
* | --- |
* | "Something went wrong" |
*
* @param {Onboarding_V1_Pick_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_pick_error = /** @type {((inputs?: Onboarding_V1_Pick_ErrorInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Pick_ErrorInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_pick_error(inputs)
	if (locale === "de") return de_onboarding_v1_pick_error(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_pick_error(inputs)
	if (locale === "tr") return tr_onboarding_v1_pick_error(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_pick_error(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_pick_error(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_pick_error(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_pick_error(inputs)
	return es_419_onboarding_v1_pick_error(inputs)
});